// CustomerListTableWithDialog.jsx
import { useEffect, useMemo, useState } from 'react';
import {
  Avatar,
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  InputAdornment,
  Link,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Stack,
  TextField,
  // TextField,
  Typography,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { post } from 'api';
import { enqueueSnackbar } from 'notistack';
import IconifyIcon from 'components/base/IconifyIcon';
// import DashboardMenu from 'components/common/DashboardMenu';
import DataGridPagination from 'components/pagination/DataGridPagination';
import StyledTextField from 'components/styled/StyledTextField';

const GedaCheckList = () => {
  const columns = useMemo(
    () => [
      // {
      //   field: 'view',
      //   headerName: 'View',
      //   sortable: false,
      //   minWidth: 80,
      //   renderCell: () => (
      //     <Link variant="body2" sx={{ fontWeight: 400 }} href="/customer-details">
      //       <RemoveRedEyeOutlinedIcon />
      //     </Link>
      //   ),
      // },
      {
        field: 'client',
        headerName: 'Client',
        minWidth: 240,
        sortable: false,
        filterable: false,
        flex: 1,
        renderCell: (params) => {
          const { firstName, lastName, mobile } = params.row;
          return (
            <Stack direction="row" alignItems="center" spacing={1.5}>
              <Avatar
                alt={firstName}
                src={firstName}
                sx={{ width: 24, height: 24, bgcolor: '#977efdff' }}
              />
              <Box>
                <Typography variant="subtitle2">
                  {firstName} {lastName}
                </Typography>
                <Link href="#!" variant="caption">
                  {mobile}
                </Link>
              </Box>
            </Stack>
          );
        },
      },
      {
        field: 'uploaded',
        headerName: 'File Uploaded',
        minWidth: 150,
        sortable: false,
        filterable: false,
        renderCell: (params) => {
          const { fileUpload } = params.row.gedamanagements;
          return (
            <Stack>
              <Chip
                label={fileUpload ? 'yes' : 'no'}
                variant="soft"
                color={getStatusBadgeColor(fileUpload ? 'yes' : 'no')}
                sx={{ textTransform: 'capitalize' }}
              />
            </Stack>
          );
        },
      },
      {
        field: 'approved',
        headerName: 'File Approved',
        minWidth: 150,
        sortable: false,
        filterable: false,
        renderCell: (params) => {
          const { fileApprove } = params.row.gedamanagements;
          return (
            <Stack>
              <Chip
                label={fileApprove ? 'yes' : 'no'}
                variant="soft"
                color={getStatusBadgeColor(fileApprove ? 'yes' : 'no')}
                sx={{ textTransform: 'capitalize' }}
              />
            </Stack>
          );
        },
      },
      {
        field: 'report',
        headerName: 'Feasibility Report Status',
        minWidth: 200,
        sortable: false,
        filterable: false,
        renderCell: (params) => {
          const { feasibilityReportStatus } = params.row.gedamanagements;
          return (
            <Stack>
              <Chip
                label={feasibilityReportStatus || '-'}
                variant="soft"
                color={getStatusBadgeColor(feasibilityReportStatus)}
                sx={{ textTransform: 'capitalize' }}
              />
            </Stack>
          );
        },
      },
      {
        field: 'meter',
        headerName: 'Meter Charges Paid',
        minWidth: 200,
        sortable: false,
        filterable: false,
        renderCell: (params) => {
          const { meterCharges } = params.row.gedamanagements;
          return (
            <Stack>
              <Chip
                label={meterCharges || '-'}
                variant="soft"
                color={getStatusBadgeColor(meterCharges)}
                sx={{ textTransform: 'capitalize' }}
              />
            </Stack>
          );
        },
      },
      {
        field: 'geda',
        headerName: 'GEDA Status',
        width: 150,
        sortable: false,
        filterable: false,
        renderCell: (params) => (
          <Button variant="outlined" size="small" onClick={() => handleOpenDialog(params.row)}>
            Update
          </Button>
        ),
      },
      // {
      //   field: 'action',
      //   headerName: 'Action',
      //   sortable: false,
      //   align: 'right',
      //   width: 60,
      //   headerAlign: 'right',
      //   renderCell: () => <DashboardMenu />,
      // },
    ],
    [],
  );
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [total, setTotal] = useState(0);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
    search: '',
  });
  // const [feasibility, setFeasibility] = useState('');
  const [formData, setFormData] = useState({
    fileUpload: '',
    fileApprove: '',
    feasibilityReportStatus: 'Rejected',
    remark: '',
    meterCharges: '',
  });
  useEffect(() => {
    const timeOut = setTimeout(() => {
      setPaginationModel((prev) => ({ ...prev, search }));
    }, 700);
    return () => clearTimeout(timeOut);
  }, [search]);

  useEffect(() => {
    if (selectedRow) {
      setFormData({
        fileUpload: selectedRow.gedamanagements.fileUpload || false,
        fileApprove: selectedRow.gedamanagements.fileApprove || false,
        feasibilityReportStatus: selectedRow.gedamanagements.feasibilityReportStatus || '',
        remark: selectedRow.gedamanagements.remark || '',
        meterCharges: selectedRow.gedamanagements.meterCharges || '',
      });
    }
  }, [selectedRow]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      const updated = { ...prev };

      // convert boolean fields properly
      if (name === 'fileUpload' || name === 'fileApprove') {
        updated[name] = value === 'true';
      } else {
        updated[name] = value;
      }

      // reset dependent fields if step breaks
      if (name === 'fileUpload' && value !== 'true') {
        updated.fileApprove = false;
        updated.feasibilityReportStatus = '';
        updated.remark = '';
        updated.meterCharges = '';
      } else if (name === 'fileApprove' && value !== 'true') {
        updated.feasibilityReportStatus = '';
        updated.remark = '';
        updated.meterCharges = '';
      } else if (name === 'feasibilityReportStatus' && !value) {
        updated.remark = '';
        updated.meterCharges = '';
      }

      return updated;
    });
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      // /list_gedaManagement
      const response = await post('users/list_customers_stages', {
        page: paginationModel.page + 1,
        limit: paginationModel.pageSize,
        search: paginationModel.search,
        type: 'liasioning',
      });
      if (response.status == 200) {
        setData(response.data.data);
        setTotal(response.data.total);
      } else {
        setData([]);
        enqueueSnackbar(response.message || 'Error while fetching Customer', {
          variant: 'error',
          autoHideDuration: 3000,
        });
      }
    } catch (error) {
      enqueueSnackbar(error.message || 'Error while fetching Customer', {
        variant: 'error',
        autoHideDuration: 3000,
      });
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [paginationModel]);

  const handleOpenDialog = (row) => {
    setSelectedRow(row);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRow(null);
    setFormData({
      fileUpload: '',
      fileApprove: '',
      feasibilityReportStatus: 'Rejected',
      remark: '',
      meterCharges: '',
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        fileUpload: formData.fileUpload,
        fileApprove: formData.fileApprove,
        feasibilityReportStatus: formData.feasibilityReportStatus,
        remark: formData.remark,
        meterCharges: formData.meterCharges,
      };

      const response = await post(
        `users/update_gedaManagement/${selectedRow.gedamanagements._id}`,
        payload,
      );

      if (response.status === 200) {
        enqueueSnackbar('GEDA details updated successfully', { variant: 'success' });
        handleCloseDialog();
        fetchData(); // refresh table
      } else {
        enqueueSnackbar(response.message || 'Failed to update GEDA details', { variant: 'error' });
      }
    } catch (error) {
      enqueueSnackbar(error.message || 'Something went wrong', { variant: 'error' });
    }
  };

  const getStatusBadgeColor = (val) => {
    switch (val) {
      case 'yes':
        return 'success';
      case 'hold':
        return 'info';
      case 'reject':
        return 'error';
      case 'no':
        return 'error';
      default:
        return 'info';
    }
  };

  return (
    <>
      <Box sx={{ width: '100%', p: { xs: 3, md: 5 } }}>
        <StyledTextField
          id="search-box"
          type="search"
          fullWidth
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search Customer Name"
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <IconifyIcon icon="material-symbols:search-rounded" fontSize={20} />
                </InputAdornment>
              ),
            },
          }}
          sx={{
            maxWidth: { sm: 200, md: 240 },
            flexGrow: { xs: 1, sm: 0 },
            mb: 3,
          }}
        />
        <DataGrid
          loading={loading}
          rowHeight={72}
          rows={data}
          columns={columns}
          getRowId={(row) => row._id}
          pagination
          paginationMode="server"
          rowCount={total}
          paginationModel={paginationModel} // { page: 0, pageSize: 10 }
          onPaginationModelChange={setPaginationModel}
          pageSizeOptions={[5, 10, 20]}
          sx={{
            '& .margin': {
              pr: 3,
            },
            '& .MuiDataGrid-columnHeaders': {
              minWidth: '100%',
            },
          }}
          slots={{
            basePagination: (props) => <DataGridPagination showFullPagination {...props} />,
          }}
        />
      </Box>
      {/* DIALOG FORM */}
      <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
        <DialogTitle>Update GEDA Details – {selectedRow?.name}</DialogTitle>

        <DialogContent>
          <Box component="form" id="gedaForm" onSubmit={handleSubmit} sx={{ mt: 1 }}>
            {/* a. Document uploaded */}
            <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
              a. Is Document uploaded in GEDA portal
            </Typography>
            <RadioGroup row name="fileUpload" value={formData.fileUpload} onChange={handleChange}>
              <FormControlLabel value={true} control={<Radio />} label="Yes" />
              <FormControlLabel value={false} control={<Radio />} label="No" />
            </RadioGroup>

            {/* b. Approved by GEDA */}
            <Typography variant="subtitle2" sx={{ mt: 2, mb: 0.5 }}>
              b. Is Document Approved by GEDA portal
            </Typography>
            <RadioGroup row name="fileApprove" value={formData.fileApprove} onChange={handleChange}>
              <FormControlLabel
                value={true}
                control={<Radio />}
                label="Yes"
                disabled={formData.fileUpload !== true}
              />
              <FormControlLabel
                value={false}
                control={<Radio />}
                label="No"
                disabled={formData.fileUpload !== true}
              />
            </RadioGroup>

            {/* c. Feasibility */}
            <Typography
              variant="subtitle2"
              sx={{ mt: 2, mb: 0.5 }}
              // value={formData.feasibilityReportStatus}
            >
              c. Is Feasibility report received
            </Typography>
            <Select
              fullWidth
              name="feasibilityReportStatus"
              value={formData.feasibilityReportStatus}
              onChange={handleChange}
              displayEmpty
              disabled={formData.fileApprove !== true}
            >
              <MenuItem value="">Select</MenuItem>
              <MenuItem value="yes">Yes</MenuItem>
              <MenuItem value="awaiting">Awaiting</MenuItem>
              <MenuItem value="rejected">Rejected</MenuItem>
            </Select>
            {formData?.feasibilityReportStatus === 'rejected' && (
              <>
                <TextField
                  fullWidth
                  sx={{ mt: 2 }}
                  label="Remark (if Rejected)"
                  name="remark"
                  variant="outlined"
                  value={formData.remark}
                  onChange={handleChange}
                />
                {/* <TextField
                  fullWidth
                  sx={{ mt: 2 }}
                  label="Document Link"
                  name="docLink"
                  variant="outlined"
                /> */}
              </>
            )}

            {/* d. Meter charges */}
            <Typography variant="subtitle2" sx={{ mt: 2, mb: 0.5 }}>
              d. Is Meter Charges paid
            </Typography>
            <Select
              fullWidth
              name="meterCharges"
              defaultValue={formData.meterCharges}
              onChange={handleChange}
              displayEmpty
              disabled={!(formData.feasibilityReportStatus == 'yes')}
            >
              <MenuItem value="">Select</MenuItem>
              <MenuItem value="yes">Yes</MenuItem>
              <MenuItem value="no">No</MenuItem>
              <MenuItem value="hold">Hold</MenuItem>
            </Select>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancel</Button>
          <Button type="submit" form="gedaForm" variant="contained">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default GedaCheckList;
